import { useEffect, useState } from 'react';

const globalHydrated = {
  isHydrated: false,
};

/**
 * Hook to determine if the page is 'hydrated'.
 * @reference https://reactjs.org/docs/react-dom.html#hydrate
 *
 * On server rendered content, it is false.
 * On initial client load (pre-hydration), it is false.
 * After the React app has hydrated the server-rendered HTML, it is true.
 */
export const useIsHydrated = () => {
  const [isHydrated, setIsHydrated] = useState(globalHydrated.isHydrated);

  useEffect(() => {
    if (isHydrated) return;
    setIsHydrated((globalHydrated.isHydrated = true));
  }, [isHydrated]);

  return isHydrated;
};
